/* eslint-disable prefer-destructuring, no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { lineUpPicSounds } from '@/utils/sounds';
import { DEVICE } from '@/constants';
import { OS } from '@/utils/detectDevice';
import LineUpDrag from '../LineUpDrag';
import './style.less';

// 被拖动div
let dv = null;
// transition执行次数
let transitionNum = 0;

class LineUpTxt extends React.Component {
  static propTypes = {
    finished: PropTypes.func,
    exercisesData: PropTypes.object,
    changeBtn: PropTypes.func,
    retryBtn: PropTypes.func,
    url: PropTypes.string,
    audioPlay: PropTypes.func,
    soundsUrl: PropTypes.string,
  };

  state = {
    pickOutData: null,
    show: true,
  };

  componentDidMount() {
    const { exercisesData } = this.props;
    this.init(exercisesData);
    this.resizeHandler();
    window.addEventListener('resize', this.resizeHandler);
  }

  componentWillReceiveProps(nextProps) {
    nextProps.url !== this.props.url && this.init(nextProps.exercisesData);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  }

  init = (exercisesData) => {
    const match = exercisesData.root[0].tasks[0].task[0].matches[0].match;
    const Data = [];
    match.forEach((item, index) => {
      Data.push({
        txt: item._attr.text._value,
        audio: '',
        val: index + 1,
      });
    });
    this.arrRandom(Data);
    this.setState({
      pickOutData: Data,
    });
  }

  arrRandom = (data) => {
    const arr = data;
    arr.sort(() => Math.random() - 0.5);
  }

  resizeHandler = () => {
    if (OS.TYPE === DEVICE.PC) {
      const offsetT = document.getElementById('question').offsetTop + (window.innerHeight * 39 / 768);
      const height = document.getElementById('question').clientHeight;
      document.getElementById('optionWrapper').style.height = `${window.innerHeight - offsetT - height}px`;
    }
  }

  handleCheck = () => {
    const questionList = document.querySelectorAll('.finished');
    let right = true;
    questionList.forEach((item) => {
      const txtdv = item.childNodes[1];
      if (item.dataset.val === txtdv.dataset.val) {
        txtdv.className = 'line-up-drag-txt right';
      } else {
        right = false;
        txtdv.className = 'line-up-drag-txt wrong';
      }
    });
    this.props.retryBtn(true);
    if (right) {
      const { soundsUrl } = this.props;
      this.handlePlay(`${soundsUrl}${lineUpPicSounds.allRight}`);
      this.props.finished();
    }
  }

  handleRetry = () => {
    document.querySelector('.option-modal').className = 'option-modal';
    this.props.changeBtn(true);
    this.props.retryBtn(false);
    this.setState({ show: false }, () => {
      this.setState({ show: true });
    });
  }

  handleMouseup = (dragDiv, x, y) => {
    dv = dragDiv;
    const dvR = x + dv.clientWidth;
    const dvB = y + dv.clientHeight;
    let mouseup = false;
    // 可视窗口上下左右距离
    document.querySelectorAll('.questionli').forEach((item) => {
      const dvWrapper = item;
      const conT = item.offsetTop - 80;
      const conB = conT + item.clientHeight + 160;
      const conL = item.offsetLeft - 80;
      const conR = conL + item.clientWidth + 160;
      dv.className = 'line-up-drag-txt';
      // 在单词摆放区域添加否则回到原来位置
      if ((x > conL && dvR < conR && y > conT && dvB < conB) && !mouseup) {
        mouseup = true;
        dvWrapper.childNodes[0].style.display = 'none';
        item.appendChild(dv);
        dvWrapper.className = 'finished';
        document.querySelectorAll('.questionli').length < 1
          && (document.querySelector('.option-modal').className = 'option-modal block')
          && this.props.changeBtn(false);
      }
      dv.style.left = `${dv.offsetLeft}px`;
      dv.style.top = `${dv.offsetTop}px`;
    });
    document.querySelector('.option-list').childNodes.forEach((item) => {
      dv = item;
      dv.style.left = `${item.offsetLeft}px`;
      dv.style.top = `${item.offsetTop}px`;
    });
  }

  handleTransitionend = () => {
    // 放大缩小
    transitionNum += 1;
    transitionNum === 2 && document.querySelectorAll('.blank').forEach((item) => {
      const word = document.getElementById(item.childNodes[0].id);
      word.className = 'word position animation1';
      transitionNum = 0;
      word.removeEventListener('transitionend', this.handleTransitionend);
      document.querySelectorAll('.word-dv').length === 0
        && word.addEventListener('animationend', this.handleAnimationend);
    });
  }

  handleAnimationend = () => {
    this.handleRetry();
  }

  handleParseInt = val => parseInt(val.replace('px', ''), 10);

  handleSounds = () => {
    const { soundsUrl } = this.props;
    this.handlePlay(`${soundsUrl}${lineUpPicSounds.handle}`);
  }

  handlePlay = (src) => {
    this.props.audioPlay(src, { type: 'exercise' });
  }

  render() {
    const { pickOutData } = this.state;
    return (
      <div className="line-up-txt-container">
        {this.state.show
          && (
            <ul id="question" className="ul-question">
              <li className="questionli" data-val="1"><div className="first" /></li>
              <li className="questionli" data-val="2"><div className="next" /></li>
              <li className="questionli" data-val="3"><div className="then" /></li>
              <li className="questionli" data-val="4"><div className="last" /></li>
            </ul>
          )
        }
        <div className="line-up-professor" />
        <div className="line-up-txt-option" id="optionWrapper">
          {this.state.show
            && (
              <div className="option-list">
                {
                  pickOutData && pickOutData.map((item, index) => (
                    <LineUpDrag
                      key={`${index + 1}`}
                      ref={this.LineUpDragRef}
                      index={index}
                      item={item}
                      type="txt"
                      mouseup={this.handleMouseup}
                      handleSounds={this.handleSounds}
                    />
                  ))
                }
              </div>
            )
          }
        </div>
        <div className="option-modal" />
      </div>
    );
  }
}

export default LineUpTxt;
